import Vue from "vue";
import Vuex from "vuex";
import Cookies from 'js-cookie'
import {
	getLanguage
} from '@/lang/index'
Vue.use(Vuex);

import javaService from "@/utils/request"
import {
	setToken,
	getToken,
	removeToken
} from '@/utils/auth'


export default new Vuex.Store({
	state: {
		token: getToken(),
		name: '',
		avatar: '',
		info: {},
		cont: 0,
		language: getLanguage(),
		isMobile: false,
		routerMap:[
			{
				chinese:'行业动态',
				name:'HangYeDongTai',
				routeName:'',
				id:1,
				lang:'menu.menu2',
				path:''
			},
			{
				chinese:'新闻中心',
				name:'News',
				routeName:'News',
				id:16,
				lang:'header.news',
				path:'/news'
			},
			{
				chinese:'产品中心',
				name:'Product',
				routeName:'Product',
				id:19,
				lang:'header.product',
				path:'/product'
			},
			{
				chinese:'员工心得',
				name:'YuanGongXinDe',
				routeName:'',
				id:18,
				fid:16,
				lang:'menu.menu3'
			},
			{
				chinese:'快讯',
				name:'KuaiXun',
				routeName:'ArticleList2',
				id:2,
				hidden:true,
				path:'/article_list2'
			},
			{
				chinese:'生产报表',
				name:'ShengChanBaoBiao',
				routeName:'',
				id:3,
				hidden:true
			},
			{
				chinese:'鸿科文化',
				name:'Culture',
				routeName:'Culture',
				id:5,
				path:'/culture',
				lang:'header.culture'
			},
			{
				chinese:'公司新闻',
				name:'GongSiXinWen',
				routeName:'',
				id:17,
				fid:16,
				lang:'menu.menu1'
			},
			{
				chinese:'鸿科党建',
				name:'Party',
				routeName:'Party',
				id:20,
				path:'/party',
				lang:'header.party'
			}
			
		]
	},
	mutations: {
		SET_TOKEN: (state, token) => {
			state.token = token
		},
		SET_NAME: (state, name) => {
			state.name = name
		},
		SET_AVATAR: (state, avatar) => {
			state.avatar = avatar
		},
		SET_INFO: (state, info) => {
			state.info = info
		},
		INIT_CONT: (state) => {
			state.cont = 0
		},
		SET_LANGUAGE: (state, language) => {
			state.language = language
			Cookies.set('language', language)
		},
		GET_ISMOBILE: (state, isMobile) => {
			state.isMobile = isMobile
		}
	},
	actions: {
		//获取是否是手机
		getIsMobile({
			commit
		}, isMobile) {
			
			commit('GET_ISMOBILE', isMobile)
		},
		/* 登录 */
		login({
			commit
		}, userInfo) {
			const {
				username,
				password
			} = userInfo
			return new Promise((resolve, reject) => {
				postlogin({
					username: username.trim(),
					password: password,
					userFlag: 1
				}).then(response => {
					const data = response
					commit('SET_TOKEN', data.token)
					commit('INIT_CONT')
					setToken(data.token)
					resolve()
				}).catch(error => {
					reject(error)
				})
			})
		},

		/* 用户信息 */
		getInfo({
			commit,
			state
		}) {
			return new Promise((resolve, reject) => {
				getInfo(state.token).then(response => {
					const data = response
					if (!data) {
						reject('验证失败，请重新登录')
					}
					const {
						nickName,
						avatar
					} = data.result
					commit('SET_INFO', data.result)
					commit('SET_NAME', nickName)
					commit('SET_AVATAR', avatar)
					resolve(data)
				}).catch((error) => {
					reject(error)
				})
			})
		},
		/* 退出 */
		logout({
			commit,
			// state
		}) {
			return new Promise((resolve, /* reject */ ) => {
				commit('SET_TOKEN', '')
				commit('SET_NAME', '')
				removeToken()
				resolve()
				//联调时放开
				// logout(state.token).then(() => {
				//   commit('SET_TOKEN', '')
				//   removeToken()
				//   resolve()
				// }).catch(error => {
				//   reject(error)
				// })
			})
		},
		// production(){
		//   return new Promise((resolve) =>{
		//     rou().then(res=>{
		//       resolve(res.result)
		//     })
		//   })
		// },
		resetToken({
			commit,
			state
		}) {
			commit('SET_TOKEN', '')
			state.name = ''
			removeToken()
		},
		setLanguage({
			commit
		}, language) {
			commit('SET_LANGUAGE', language)
		},
	},
	modules: {}
});


function postlogin(data) {
	return javaService({
		url: '/login',
		method: 'post',
		data: handel(data),
		isLoading: true
	})
}

// function rou() {
//   return javaService({
//     url: '/front/classificationList',
//     method: 'get'
//   })
// }

function getInfo() {
	return javaService({
		url: '/user/frontInfo',
		method: 'get',
		isLoading: true
	})
}

// function logout() {
//   return javaService({
//     url: '/user/logout',
//     method: 'post'
//   })
// }

function handel(data) {
	var params = new URLSearchParams()
	for (const key in data) {
		params.append(key, data[key])
	}
	return params
}
